import { useEffect, useState } from "react";
import IAuthProps from "components/Auth/IAuthProps";
import Login from "pages/Login/Login";
// import Register from "pages/Prenotazione/Assistito/Register";

import { Skeleton } from "antd";
import {  setLogin } from "core/redux/features/session/sessionSlice";
// import { getReduxRegisterData } from "utils/ReduxUtils";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";
import NavigationManager from "utils/NavigationManager";
import { Riepilogo } from "pages";

import "./Auth.css";
import { Enhanced } from "utils/ReactUtils";

// enum authenticationModeEnum {
// 	login,
// 	newAccount,
// }

const Auth: React.FC<IAuthProps> = ({ OnChangePasswordRequest,sessionInfo,t,handleError,dispatch }) => {

	const { MoveStep } = NavigationManager(sessionInfo);
	const [loading, setLoading] = useState<boolean>(true);
	// const [authenticationMode, setAuthenticationMode] = useState<authenticationModeEnum>(authenticationModeEnum.login);

	// const OnSubmitRegister = (registerData: IRegisterData) => {
	// 	dispatch(setRegisterData(getReduxRegisterData(registerData)));
	// 	MoveStep("next");
	// };

	const SetLoggedIn = (nominativoUtente: string) => {
		dispatch(setLogin([true, nominativoUtente]));
		MoveStep("next");
	};

	useEffect(() => {
		performAsyncFunction(async () => {
			if (sessionInfo.isLogged) MoveStep("next");
			setLoading(false);
		}, handleError);
	}, [MoveStep, handleError, sessionInfo.isLogged]);

	const OnLoginSuccess = (nominativoUtente: string) => {
		SetLoggedIn(nominativoUtente);
	};

	const ChangeAuthenticationMode = () => {
		// authenticationMode === authenticationModeEnum.login
		// 	? setAuthenticationMode(authenticationModeEnum.newAccount)
		// 	: setAuthenticationMode(authenticationModeEnum.login);
		MoveStep("next");
	};

	return (
		<>
			<Skeleton loading={loading}>
				{/* {authenticationMode === authenticationModeEnum.login ? (
					<> */}
				<div className="title-auth">
					<span>{t("login.title")}</span>
				</div>
				<Riepilogo />

				<Login OnLogin={OnLoginSuccess} OnChangePasswordRequest={OnChangePasswordRequest} ChangeAuthenticationMode={ChangeAuthenticationMode} />
				{/* </>
				) : (
					<>
						<Riepilogo />
						<Register OnSubmit={OnSubmitRegister} ChangeAuthenticationMode={ChangeAuthenticationMode} />
					</>
				)} */}
			</Skeleton>
		</>
	);
};

export default Enhanced( Auth,{componentNamespace:"Auth"});
